import { Link } from "gatsby"
import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const footerLinks = [
  { name: "Shipping & Returns", handle: "shipping-returns" },
  { name: "FAQ’S", handle: "faq" },
  { name: "Privacy Policy", handle: "privacy-policy" },
  { name: "Press", handle: "press" },
  { name: "Instagram", handle: "https://www.instagram.com/uniform_object/" },
]

export function Footer({ currentRouteIndex }) {
  return (
    <footer
      className={`block w-full mt-10 text-footer-menu nav-item-${currentRouteIndex}`}
    >
      <StaticImage
        src="../../img/chain.png"
        alt="chain full screen"
        className="w-full bg-repeat-x"
      />

      <div className="flex items-center justify-between max-w-screen-lg mx-auto lg:justify-start ">
        <div className="order-2 w-20 lg:w-20 lg:order-1">
          <StaticImage
            src="https://cdn.shopify.com/s/files/1/0561/1464/3101/files/uo_lamb-snake_insignia_white.png?v=1631059886"
            alt="a fancy footer decoration"
          />
        </div>

        <div className="order-2 hidden w-32 lg:ml-5 lg:block">
          <StaticImage
            src="../../img/left-1-footer.png"
            alt="a fancy footer decoration"
          />
        </div>

        <div className="grid order-3 grid-cols-2 grid-rows-3 row-span-2 gap-2 mr-2 footer-links lg:ml-8">
          {footerLinks.map(link => (
            <div key={link.handle}>
              {link.handle.startsWith("https://") ? (
                <a href={link.handle} key={link.handle}>
                  {link.name}
                </a>
              ) : (
                <Link
                  activeClassName="underline"
                  to={
                    link.handle.startsWith("https://")
                      ? link.handle
                      : `/pages/${link.handle}`
                  }
                  key={link.handle}
                >
                  {link.name}
                </Link>
              )}
            </div>
          ))}
          <div>©UNIFORM OBJECT</div>
        </div>
        <div className="justify-end flex-grow order-4 hidden lg:flex">
          <StaticImage
            className="w-20 mr-3 lg:ml-auto"
            src="https://cdn.shopify.com/s/files/1/0561/1464/3101/files/uo_rune_white.png?v=1631059910"
            alt="a fancy footer decoration"
          />
        </div>
      </div>
    </footer>
  )
}
